import { AxiosError } from 'axios';

/**
 * Attempts to extract the error message from an Error.
 * Useful for displaying API error messages in the UI.
 */
export const parseError = (err: any, fallBackMessage = 'An error occurred') => {
  let res: any = '';

  if (err instanceof AxiosError) {
    // API model validation errors follow this format:
    // err.response.data.errors { key: string, key2: string }
    const validationErrors = err.response?.data?.errors;
    if (validationErrors) {
      res =
        Object.entries(validationErrors)
          .map(([k, v]) => `${k}: ${v}`)
          .join('. ') + '.';
    } else {
      // API exception errors follow this format:
      // err.response.data: string
      res = err.response?.data ?? fallBackMessage;
    }
  } else {
    // Regular Javascript errors tend to have a .message
    res = err.message ?? fallBackMessage;
  }

  return res.toString();
};
